import { Container } from "@mui/material";
import styles from "./ConceptBasicInformation.module.scss";
import { SkeletonType } from "Explore/Config/ImageType";
import { LoadingSimpleComponent } from "Explore/Components";
import { useState } from "react";
import { Modal } from "antd";

const BasicInformation = ({ summary }) => {
  const [seeMore, setSeeMore] = useState(false);

  return (
    <>
      <div className={styles["container"]}>
        <Container maxWidth="lg" className={styles["basic-information"]}>
          <div className={styles["basic-information--title"]}>
            <LoadingSimpleComponent
              component={<h1>{summary?.data.name}</h1>}
              type={SkeletonType.INPUT}
              isLoading={summary.isLoading}
              className={styles["basic-information--title__wrapper"]}
            />
          </div>
          <div className={styles["basic-information--definition"]}>
            <LoadingSimpleComponent
              component={
                <p onClick={() => setSeeMore(true)}>
                  {summary?.data.definition}
                </p>
              }
              type={SkeletonType.INPUT}
              isLoading={summary.isLoading}
              className={styles["basic-information--definition__wrapper"]}
            />
          </div>
        </Container>
      </div>

      <Modal
        title="Definition"
        placement={"bottom"}
        onCancel={() => setSeeMore(false)}
        open={seeMore}
        footer={null}
      >
        <p>{summary.data?.definition}</p>
      </Modal>
    </>
  );
};

export default BasicInformation;
